import React from 'react';
import { Heading, Text, Box } from 'components';

interface NotesProps {
  notes: string;
}

export const Notes = ({ notes }: NotesProps) => {
  if (!notes) return null;

  return (
    <Box>
      <Heading level={2} size='medium'>
        Additional Notes
      </Heading>
      <Text sx={{ whiteSpace: 'break-spaces' }}>{notes}</Text>
    </Box>
  );
};
